// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCacheToolFactory } from './DataCacheToolFactory';
import { CustomEvent } from '@shared/utils/CustomEvents';
import { ErrorInformationStorage } from '../ErrorInformationStorage';
import { DynProperty } from '../DynProperty';
import { OldThemeStyleGroup, OldThemeStyleRestorer } from '@front/controls/misc/OldThemeStyleRestorer';
class _ToolsCache {
    constructor() {
        this.OnAddTool = new CustomEvent();
        this.OnRemoveTool = new CustomEvent();
        this.OnChangeTool = new CustomEvent();
        this.Tools = [];
    }
    AddTool(tool, e) {
        tool.OnUpdate.Subscribe(this.UpdateTool, this);
        this.Tools.push(tool);
        this.OnAddTool.Raise(tool, e);
    }
    RemoveTool(tool) {
        tool.OnUpdate.UnSubscribe(this.UpdateTool, this);
        const remIndex = this.Tools.indexOf(tool);
        this.Tools.splice(remIndex, 1);
        this.OnRemoveTool.Raise(tool);
        // delete tool;
    }
    UpdateTool(tool) {
        this.OnChangeTool.Raise(tool);
    }
    CheckToolEnabilityAndUpdateInstrument(tool, ins) {
        if (tool.AssignedSymbol === ins.GetInteriorID()) {
            // Non fixed list instrument case
            tool.Instrument = ins;
            return true;
        }
        return false;
    }
    GetTools(ins) {
        const res = [];
        if (ins == null) {
            return res;
        }
        for (let i = 0; i < this.Tools.length; i++) {
            const tool = this.Tools[i];
            if (this.CheckToolEnabilityAndUpdateInstrument(tool, ins)) {
                res.push(tool);
            }
        }
        return res;
    }
    GetToolById(toolId) {
        const res = null;
        if (!toolId) {
            return res;
        }
        for (let i = 0; i < this.Tools.length; i++) {
            const tool = this.Tools[i];
            if (tool.ID === toolId) {
                return tool;
            }
        }
        return res;
    }
    Clear() {
        this.Tools.length = 0;
    }
    GetToolsForSave() {
        const result = [];
        for (let i = 0; i < this.Tools.length; i++) {
            const tool = this.Tools[i];
            const props = DynProperty.serialize(tool.Properties());
            const type = tool.ToolType;
            result.push({ type, properties: props });
        }
        return JSON.stringify(result);
    }
    CreateToolsFromSaves(properies, dataCache, isPropertiesFromOldVersion) {
        if (!properies) {
            return;
        }
        this.Clear();
        let tools = [];
        try {
            tools = JSON.parse(properies);
        }
        catch (e) {
            ErrorInformationStorage.GetException(e);
            tools = [];
        }
        for (const tool of tools) {
            const newTool = DataCacheToolFactory.Create(tool.type, dataCache);
            const deserializedProperties = DynProperty.deserialize(tool.properties);
            let filteredProperties = deserializedProperties;
            if (isPropertiesFromOldVersion) {
                const newDefProperties = newTool.Properties();
                filteredProperties = OldThemeStyleRestorer.removeOldDarkThemeDefaultStyleProperties(deserializedProperties, OldThemeStyleGroup.DrawingGroup, newDefProperties);
            }
            newTool.callBack(filteredProperties);
            newTool.OnUpdate.Subscribe(this.UpdateTool, this);
            this.Tools.push(newTool);
        }
    }
}
export var ToolsCacheAction;
(function (ToolsCacheAction) {
    ToolsCacheAction[ToolsCacheAction["Add"] = 0] = "Add";
    ToolsCacheAction[ToolsCacheAction["Remove"] = 1] = "Remove";
    ToolsCacheAction[ToolsCacheAction["Update"] = 2] = "Update";
    ToolsCacheAction[ToolsCacheAction["Synhronize"] = 3] = "Synhronize";
})(ToolsCacheAction || (ToolsCacheAction = {}));
export const ToolsCache = new _ToolsCache();
